import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function TermsAndConditions() {
  useEffect(() => {
    AOS.init({ once: true, duration: 900, easing: "ease-in-out" });
  }, []);

  return (
    <>
      {/* Spacer for sticky header */}
      <div style={{ height: 0 }} />

      {/* Top Banner */}
      <section className="py-5 position-relative overflow-hidden bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto" data-aos="fade-up">
              <h1
                className="fw-bold mb-3 text-center"
                style={{
                  fontSize: "2.6rem",
                  fontFamily: "'Poppins', sans-serif",
                  color: "#2e3d9c",
                }}
              >
                Terms & <span
                  style={{
                    background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
                    color: "transparent",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                  }}
                >
                  Conditions
                </span>
              </h1>
              <p className="text-center text-secondary mb-4" style={{ fontSize: "1.1rem" }}>
                Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-4 bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="card border-0 shadow-sm" style={{ borderRadius: "12px" }}>
                <div className="card-body p-4 p-md-5">
                  <div data-aos="fade-up">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      1. Agreement to Terms
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      By accessing or using the services of Nexen Consults LLC, you agree to be bound by
                      these Terms and Conditions. If you disagree with any part of these terms, then you may not access our services.
                      These Terms apply to all visitors, users, and others who access or use our services.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      2. Services Description
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We provide US tax and professional services. Our services depend on the information provided by clients.
                      The accuracy and completeness of the information you provide directly impacts the quality and effectiveness
                      of the services we deliver.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      3. SMS / Communication Terms
                    </h2>
                    <p className="text-secondary mb-3" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      <strong>This section governs how we communicate with you via SMS and other methods.</strong>
                    </p>
                    <div className="bg-light p-4 rounded mb-4" style={{ fontSize: "1rem", borderLeft: "4px solid #6B46C1" }}>
                      <p className="mb-2 text-secondary" style={{ lineHeight: "1.8" }}>
                        <strong>SMS Communications:</strong>
                      </p>
                      <ul className="mb-3 text-secondary" style={{ lineHeight: "2" }}>
                        <li>SMS messages are sent only after you have provided consent</li>
                        <li><strong>Purpose:</strong> SMS messages are used for confirmations, follow-ups, and service updates</li>
                        <li><strong>Message Frequency:</strong> 1-3 messages per interaction, depending on your service needs</li>
                        <li>Message and data rates may apply, depending on your mobile carrier plan</li>
                      </ul>
                      <p className="mb-2 text-secondary" style={{ lineHeight: "1.8" }}>
                        <strong>Opt-Out Instructions:</strong>
                      </p>
                      <ul className="mb-0 text-secondary" style={{ lineHeight: "2" }}>
                        <li>To stop receiving SMS messages, reply <strong>STOP</strong> to any message from us</li>
                        <li>For assistance, reply <strong>HELP</strong> to any message from us</li>
                      </ul>
                    </div>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      By subscribing and submitting, you agree to receive notifications from Nexen Consults LLC through calls and SMS. Data rates apply and messaging frequency may vary. You can unsubscribe at any time. We respect your privacy and won’t share your information with third parties.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      4. No Marketing Promise
                    </h2>
                    <div className="bg-light p-4 rounded mb-4" style={{ fontSize: "1rem", borderLeft: "4px solid #6B46C1" }}>
                      <p className="mb-0 text-secondary" style={{ lineHeight: "1.8" }}>
                        <strong>We do not send unsolicited or cold marketing messages.</strong> All communications are service-related
                        and sent only after you have provided consent or initiated contact with us.
                      </p>
                    </div>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      5. Client Responsibility
                    </h2>
                    <p className="text-secondary mb-3" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      As a client using our services, you have the following responsibilities:
                    </p>
                    <ul className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "2" }}>
                      <li><strong>Provide Accurate Information:</strong> You must provide accurate, current, and complete information
                        when using our services. The quality of our services depends on the accuracy of the information you provide.</li>
                      <li><strong>Review Documents:</strong> You must carefully review all documents, tax returns, and other materials
                        we prepare for you before signing or submitting them. It is your responsibility to verify the accuracy of all
                        information contained in these documents.</li>
                      <li><strong>Penalties Due to Incorrect Information:</strong> We are not responsible for any penalties, fines,
                        interest, or other consequences that may result from incorrect, incomplete, or inaccurate information provided
                        by you. You are solely responsible for ensuring that all information you provide is accurate and complete.</li>
                    </ul>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      6. Privacy Policy
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      This service is also governed by our{" "}
                      <a href="/privacy-policy" style={{ color: "#6B46C1", textDecoration: "underline" }}>
                        Privacy Policy
                      </a>
                      . Please review our Privacy Policy to understand how we collect, use, and protect your information.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      7. Payment Terms
                    </h2>
                    <p className="text-secondary mb-3" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      Payment terms for our services are as follows:
                    </p>
                    <ul className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "2" }}>
                      <li>Payment is due as specified in your service agreement or invoice</li>
                      <li>We accept various payment methods, including credit cards, debit cards, and bank transfers</li>
                      <li>All fees are non-refundable unless otherwise stated in writing</li>
                      <li>Late payments may result in suspension or termination of services</li>
                      <li>You are responsible for any taxes, duties, or fees applicable to your use of our services</li>
                      <li>We reserve the right to change our pricing at any time, with notice to existing clients</li>
                    </ul>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      8. Limitation of Liability
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      To the fullest extent permitted by applicable law, Nexen Consults LLC shall not be liable for any indirect,
                      incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred
                      directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from your
                      use of our services. Our total liability for any claims arising from or related to our services shall not
                      exceed the amount you paid to us in the twelve (12) months preceding the claim.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      9. Disclaimer of Warranties
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      Our services are provided "as is" and "as available" without warranties of any kind, either express or
                      implied, including, but not limited to, implied warranties of merchantability, fitness for a particular
                      purpose, or non-infringement. We do not warrant that our services will be uninterrupted, secure, or error-free,
                      or that defects will be corrected. While we strive to provide accurate tax and financial advice, we cannot
                      guarantee specific outcomes or results.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      10. Governing Law
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      These terms are governed by the laws of the United States.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      11. Changes to Terms
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision
                      is material, we will provide at least 30 days' notice prior to any new terms taking effect. What constitutes
                      a material change will be determined at our sole discretion. By continuing to access or use our services after
                      those revisions become effective, you agree to be bound by the revised terms.
                    </p>
                  </div>

                  <div data-aos="fade-up" className="mt-5">
                    <h2
                      className="fw-bold mb-3"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "1.8rem",
                      }}
                    >
                      12. Contact Information
                    </h2>
                    <p className="text-secondary mb-4" style={{ fontSize: "1rem", lineHeight: "1.8" }}>
                      If you have any questions about these Terms and Conditions, please contact us at:
                    </p>
                    <div className="bg-light p-4 rounded mb-4" style={{ fontSize: "1rem", borderLeft: "4px solid #6B46C1" }}>
                      <p className="mb-1"><strong>Nexen Consults LLC</strong></p>
                      <p className="mb-1">DALLAS, GA, 30132, USA</p>
                      <p className="mb-1"><strong>Email:</strong> <a href="mailto:support@nexenconsults.com" style={{ color: "#6B46C1" }}>support@nexenconsults.com</a></p>
                      <p className="mb-0"><strong>Phone:</strong> <a href="tel:+19436789878" style={{ color: "#6B46C1" }}>+1 (943) 678 9878</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bootstrap Icons CDN */}
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.3/font/bootstrap-icons.css"
      />
    </>
  );
}

